import { render, staticRenderFns } from "./ClaimBenefits.vue?vue&type=template&id=6d872234"
import script from "./ClaimBenefits.vue?vue&type=script&lang=js"
export * from "./ClaimBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports